module.exports = __webpack_public_path__ + "img/untitled.610.da1a5947.png";